import React, { useState, useEffect } from "react"
import MetaTags from 'react-meta-tags';
import { useSelector } from "react-redux";

import { Link, useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import moment from 'moment';
import { allStateContractCall, changeContractSettlement } from "../../crud/auth.crud"
import Util from "pages/Dashboard/Common/Util";

import loading from "../../assets/images/loading.gif";
import * as XLSX from 'xlsx';

const ContractManagementScreen = () => {

  const selector = useSelector(state => state)
  const history = useHistory()
  const companyData = selector.auth?.user?.member_group?.[0]?.company_group
  const companyId = companyData.id

  const [dataList, setDataList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchCondition, setSearchCondition] = useState({})
  const [page, setPage] = useState(1)
  const [listCount, setListCount] = useState(0)
  const [refresh, setRefresh] = useState(false)
  const [isListEnd, setIsListEnd] = useState(false)
  
  useEffect(() => {
    const scBody = document.getElementById("sc-body");
    if (!scBody) return;
    const handleScroll = () => {
      const scrollPosition = scBody.scrollTop;
      const scrollHeight = scBody.scrollHeight - scBody.clientHeight;
      if (scrollPosition >= scrollHeight - 1) {
        setPage(page + 1)
      }
    }
    scBody.addEventListener('scroll', handleScroll)

    return () => {
      scBody.removeEventListener('scroll', handleScroll)
    }
  }, [dataList])

  const getDataList = async () => {
    if (isLoading || isListEnd)
      return

    setIsLoading(true)
    try{
      const params = {
        company: companyId,
        state: 'Y',
        page: page,
        subject: searchCondition.subject || '',
        collect_zone: searchCondition.collectZone || ''
      }
      const response = await allStateContractCall(params)
      setListCount(response.data?.count || 0)
      if (response.status === 200) {
        let content = response?.data?.results || [];
        const newList = [...dataList, ...content]
        if (page === 1) {
          setDataList(content)
        } else {
          setDataList(newList)
        }
        if (newList.length >= response.data.count) {
          setIsListEnd(true)
        }
      }
      setIsLoading(false)
      setRefresh(false)
    } catch (error) {
      console.error(error);
      setIsLoading(false)
      setRefresh(false)
    }
  }

  const changeSearchCondition = (key, value) => {
    setSearchCondition(prev => ({...prev, [key]: value}))
  }

  const excelDownload = async () => {
    const table = document.getElementById('excel-table');
    if (!table) return;

    const rows = table.querySelectorAll('tr');
    const data = [];

    for (let i = 0; i < rows.length; i++) {
      const cells = rows[i].querySelectorAll('td, th');
      const rowData = [];

      for (let j = 0; j < cells.length; j++) {
        rowData.push(cells[j].innerText);
      }

      data.push(rowData);
    }

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array'
    });

    const blob = new Blob(
      [wbout],
      { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' }
    );

    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = `${'일반 계약 목록'}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  }
  
  const onSearch = async () => {
    if (page === 1) {
      setRefresh(true)
    } else {
      setPage(1)
    }
    setIsListEnd(false)
  }

  useEffect(() => {
    if (refresh)
      getDataList()
  }, [refresh])

  useEffect(() => {
    if (!isListEnd)
      setRefresh(true)
  }, [page, isListEnd])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>계약 관리 / 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs maintitle="Home" title="" breadcrumbItem="계약 관리" />

          <div className="d-flex w-100 gap-30">
            <div className="email-rightbar flex-grow-1">
              <Card>
                <CardBody className="padding-0">
                  <table className="input-table">
                    <tbody>
                      <tr>
                        <td className="col-10 padding-left-8 primary-bg white-text font-size-12">계약명</td>
                        <td className="col-20">
                          <input className="waver-input-box border-radius-0 w-100 margin-right-4" placeholder={'계약명을 입력하세요.'} value={searchCondition.subject || ''} onChange={(e) => {
                            changeSearchCondition('subject', e.target.value)
                          }} />
                        </td>
                        <td className="col-10 padding-left-8 primary-bg white-text font-size-12">수거구역</td>
                        <td className="col-20">
                          <input className="waver-input-box border-radius-0 w-100 margin-right-4" placeholder={'수거구역을 입력하세요.'} value={searchCondition.collectZone || ''} onChange={(e) => {
                            changeSearchCondition('collectZone', e.target.value)
                          }} />
                        </td>
                        <td className="col-10 padding-left-8 primary-bg white-text font-size-12"></td>
                        <td className="col-20"></td>
                      </tr>
                    </tbody>
                  </table>
                </CardBody>
              </Card>
            </div>
            <div className="d-flex flex-direction-column align-items-end">
              <button style={{width: 143}} type="button" className="custom-btn btn-dark-gradient border-radius-0 white-text border-none margin-right-0 margin-top-6" onClick={() => {
                onSearch()
              }}>
                검색
              </button>
              <button style={{width: 143}} type="button" className="custom-btn primary-bg margin-bottom-8 border-radius-0 white-text border-none margin-right-0 margin-top-6" onClick={() => {
                history.push('/contract-management-screen-write')
              }}>
                신규계약
              </button>
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center mb-2">
            <p className="mb-0 font-size-16"><span className="font-weight-bold">일반 계약 목록</span> [ 건수 : {listCount}건 ]</p>
            <div className="waver-pagination-btn-group" >
              <button style={{width: 143}} className="custom-btn success-bg border-radius-0 white-text border-none margin-right-0"
              onClick={() => {
                excelDownload()
              }} >
                엑셀 다운로드
              </button>
            </div>
          </div>
          <Row>
            <Col xs="12">
              <div className="email-rightbar mb-3">

                <Card>
                  <CardBody style={{padding: 0, borderRadius: 4, overflow: 'hidden'}}>
                    <div id={"sc-body"} style={{maxHeight: 660}} className="table-responsive">
                      <table id="excel-table" className="table table-hover table-centered table-nowrap mb-0 chart-table">
                        <thead className="chart-thead">
                          <tr>
                            <th scope="col">No</th>
                            <th scope="col">계약명</th>
                            {/* <th scope="col">수거구역</th> */}
                            {/* <th scope="col">희망수거일</th> */}
                            <th scope="col">정산일자</th>
                            <th scope="col">계약일자</th>
                            <th scope="col">계약기간</th>
                            <th scope="col">계약현황</th>
                          </tr>
                        </thead>
                        <tbody className="chart-tbody">
                          {dataList.map((item, index) => {
                            const contractData = item?.contract_group_data;
                            return (
                              <tr key={item.id + '_' + index} className="pointer" onClick={()=>{
                                  history.push({ pathname: '/contract-management-screen-detail', state: { ...item } })
                                }}>
                                <td>{contractData?.id}</td>
                                <td>{contractData?.subject}</td>
                                {/* <td>{contractData?.collect_zone}</td> */}
                                {/* <td>{contractData?.collection_day ? moment(contractData?.collection_day).format('YYYY-MM-DD') : ''}</td> */}
                                <td>{contractData?.settlement_date}</td>
                                <td>{moment(contractData?.created_at).format('YYYY-MM-DD')}</td>
                                <td>{moment(contractData?.start_date).format('YYYY-MM-DD')} ~ {moment(contractData?.end_date).format('YYYY-MM-DD')}</td>
                                <td style={{color: contractData.state === 'Y' ? '#023047' : '#DA0000'}}>{contractData.state === 'Y' ? ' 계약완료' : '미계약'}</td>
                              </tr>
                            )
                          })}
                          {dataList.length === 0 &&
                            <tr>
                              <td scope="row" colSpan="14">데이터가 없습니다.</td>
                            </tr>
                          }

                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                  {isLoading && <div style={{
                    position: "absolute",
                    width: '100%',
                    height: '100%',
                    top: 0,
                    left: 0,
                    background: 'rgba(255, 255, 255, 0.6)',
                    zIndex: 999,
                    display: "flex",
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}>
                    <img src={loading} alt="로딩중입니다." width={'3%'}></img>
                  </div>}
                </Card>

              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ContractManagementScreen
